<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
              <div class="alert" :class="'alert-' + flashType">
                {{ flashMessage }}
              </div>
            </div>
          </div>
          <div class="collection_location_scroll">
            <div id="details" class="collection_location_inner">
              <vue-form :state="formstate" @submit.prevent="onSubmit">
                <div class="boxs">
                  <h4>Collection Location</h4>
                </div>

                <div class="row collection_location_wrp">
                  <div class="col-sm-4">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.cityId)"
                    >
                      <label>City</label>
                      <select
                        required
                        name="cityId"
                        class="form-control"
                        v-model="primaryTrip.cityId"
                        v-on:change="getCityId($event.target.value)"
                        @change="reset()"
                        :disabled="
                          ($route.params &&
                            $route.params._id &&
                            $route.params._id != '0') ||
                          isCityDisable
                        "
                      >
                        <option value="" disabled>Select City Name</option>
                        <option
                          v-for="cityId in cities"
                          :value="cityId.id"
                          :selected="
                            cityId &&
                            primaryTrip.cityId &&
                            cityId.id === primaryTrip.cityId
                          "
                        >
                          {{ cityId.name }}
                        </option>
                      </select>
                      <field-messages
                        name="cityId"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">This is required field</div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-4">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.area)"
                    >
                      <label>Zone</label>
                      <select
                        v-model="primaryTrip.caId"
                        name="area"
                        v-on:change="getAreaById($event.target.value)"
                        @change="reset()"
                        required
                        class="form-control"
                      >
                        <option value="" disabled>Select Zone</option>
                        <option
                          v-for="(item, index) in area"
                          :key="index"
                          :value="item.id"
                          :selected="
                            item && primaryTrip.caId && item.id === primaryTrip.caId
                          "
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <field-messages
                        name="area"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">Area is a required field</div>
                      </field-messages>
                    </validate>
                  </div>
                  <!-- <div class="col-sm-4">
                                          <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.divisionOrWard)">
                                              <label>Division/Ward</label>
                                              <select v-model="primaryTrip.cdId" multiple required name="divisionOrWard" class="form-control">
                                                  <option disabled>Select Division/Ward</option>
                                                  <option v-for="(item,index) in division_ward" :key="index"  :value="item.id" :selected="primaryTrip.cdId && item && primaryTrip.cdId === item.id">
                                                      {{item.name}}
                                                  </option>
                                              </select>
                                              <field-messages name="divisionOrWard" show="$touched || $submitted" class="form-control-feedback">
                                                  <div slot="required">Division/Ward is a required field</div>
                                              </field-messages>
                                          </validate>
                                      </div> -->
                  <div class="col-sm-4">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.divisionOrWard)"
                    >
                      <label>Division / Ward</label>
                      <multiselect
                        track-by="cdName"
                        label="cdName"
                        @input="showWard"
                        v-model="primaryTrip.cdId"
                        :options="divisionWardList"
                        multiple
                        name="divisionOrWard"
                        required
                      ></multiselect>
                      <field-messages
                        name="divisionOrWard"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">This is required field</div>
                      </field-messages>
                    </validate>
                  </div>
                </div>

                <!-- <div class="col-sm-12">
                                      <div class="col-sm-4">
                                          <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.lineOrTower)">
                                              <label>Line/Tower</label>
                                              <select v-model="primaryTrip.cdlId" required name="lineOrTower" class="form-control">
                                                  <option disabled>Select Line/Tower</option>
                                                  <option v-for="(item,index) in lineOrTowers" :key="index" :value="item.id" :selected="item && primaryTrip.cdlId && item.id === primaryTrip.cdlId">
                                                      {{item.name}}
                                                  </option>
                                              </select>
                                              <field-messages name="lineOrTower" show="$touched || $submitted" class="form-control-feedback">
                                                  <div slot="required">Line/Tower is a required field</div>
                                              </field-messages>
                                          </validate>
                                      </div>
                                   </div> -->

                <div class="col-sm-12"></div>
                <div class="boxs">
                  <h4>Worker & Vehicle</h4>
                </div>
                <div class="row collection_location_wrp">
                  <div class="col-sm-4">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.driverId)"
                    >
                      <label>Driver</label>
                      <select
                        required
                        v-model="primaryTrip.driverId"
                        name="driverId"
                        class="form-control"
                      >
                        <option value="" disabled>Select Driver</option>
                        <option
                          v-for="(item, index) in driver_name"
                          :key="index"
                          :value="item.id"
                          :selected="
                            item &&
                            primaryTrip.driverId &&
                            item.id === primaryTrip.driverId
                          "
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <field-messages
                        name="driverId"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">Driver is a required field</div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-4">
                    <validate
                      auto-label
                      class="form-group"
                      :class="fieldClassName(formstate.helperId)"
                    >
                      <label>Helper</label>
                      <select
                        v-model="primaryTrip.helperId"
                        name="helperId"
                        class="form-control"
                      >
                        <option value="" disabled>Select Helper</option>
                        <option
                          v-for="(item, index) in helper_name"
                          :key="index"
                          :value="item.id"
                          :selected="
                            item &&
                            primaryTrip.helperId &&
                            item.id === primaryTrip.helperId
                          "
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <field-messages
                        name="helperId"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">Helper is a required field</div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-4">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.vehicleId)"
                    >
                      <label>Vehicle</label>
                      <select
                        required
                        v-model="primaryTrip.vehicleId"
                        name="vehicleId"
                        class="form-control"
                      >
                        <option value="" disabled>Select Vehicle</option>
                        <option
                          v-for="(item, index) in vehicle_name"
                          :key="index"
                          :value="item.id"
                          :selected="
                            item &&
                            primaryTrip.vehicleId &&
                            item.id === primaryTrip.vehicleId
                          "
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <field-messages
                        name="vehicleId"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">Vehicle is a required field</div>
                      </field-messages>
                    </validate>
                  </div>
                </div>

                <!-- <div class="boxs">
                                <h4>Trip End Location</h4>
                            </div> -->
                <!-- <div class="row collection_location_wrp">
                                <div class="col-sm-4">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.endLoc)">
                                        <label>Dump Yard</label>
                                        <select required v-model="primaryTrip.endLoc" name="endLoc" class="form-control">
                                            <option value="" disabled>Select Dump Yard</option>
                                            <option v-for="(item, index) in endLocations" :key="index" :value="item._id" :selected="
                                    item &&
                                      primaryTrip.endLoc &&
                                      item._id === primaryTrip.endLoc
                                  ">
                                                {{ item.plantName }}
                                            </option>
                                        </select>
                                        <field-messages name="endLoc" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">
                                                Dump Yard is a required field
                                            </div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div> -->

                <div class="boxs">
                  <h4>Collection Schedule</h4>
                </div>
                <div class="row collection_location_wrp collection_time_date_icon">
                  <div class="col-sm-4">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.scheduleTime)"
                    >
                      <label>Schedule Date and Time</label>
                      <datetime
                        required
                        id="scheduleTime"
                        type="datetime"
                        v-model="primaryTrip.scheduleTime"
                        :min-datetime="new Date().toISOString()"
                        lang="en"
                        name="scheduleTime"
                        @input="selectItem($event)"
                        input-class="form-control"
                        class="theme-wm"
                        placeholder="Start Date and Time"
                      ></datetime>
                      <svg
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 122.88 122.89"
                      >
                        <title>date</title>
                        <path
                          d="M81.61,4.73C81.61,2.12,84.19,0,87.38,0s5.77,2.12,5.77,4.73V25.45c0,2.61-2.58,4.73-5.77,4.73s-5.77-2.12-5.77-4.73V4.73ZM66.11,105.66c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1ZM15.85,68.94c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1Zm25.14-10.1H107c.8,0,.8,10.1,0,10.1H91.25c-.8,0-.8-10.1,0-10.1ZM15.85,87.3c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1ZM41,87.3c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1Zm25.14,0c-.8,0-.8-10.1,0-10.1H107c.8,0,.8,10.1,0,10.1Zm-75.4,18.36c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1ZM29.61,4.73C29.61,2.12,32.19,0,35.38,0s5.77,2.12,5.77,4.73V25.45c0,2.61-2.58,4.73-5.77,4.73s-5.77-2.12-5.77-4.73V4.73ZM6.4,43.47H116.47v-22a3,3,0,0,0-.86-2.07,2.92,2.92,0,0,0-2.07-.86H103a3.2,3.2,0,0,1,0-6.4h10.55a9.36,9.36,0,0,1,9.33,9.33v92.09a9.36,9.36,0,0,1-9.33,9.33H9.33A9.36,9.36,0,0,1,0,113.55V21.47a9.36,9.36,0,0,1,9.33-9.33H20.6a3.2,3.2,0,1,1,0,6.4H9.33a3,3,0,0,0-2.07.86,2.92,2.92,0,0,0-.86,2.07v22Zm110.08,6.41H6.4v63.67a3,3,0,0,0,.86,2.07,2.92,2.92,0,0,0,2.07.86H113.55a3,3,0,0,0,2.07-.86,2.92,2.92,0,0,0,.86-2.07V49.88ZM50.43,18.54a3.2,3.2,0,0,1,0-6.4H71.92a3.2,3.2,0,1,1,0,6.4Z"
                        />
                      </svg>
                      <field-messages
                        name="scheduleTime"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">Start date is a required field</div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-4">
                    <input
                      type="radio"
                      name="vehicle"
                      value="vehicle"
                      id="vehicle"
                      v-model="primaryTrip.trackBy"
                      @change="onSelectRadio('vehicle')"
                    />
                    <label for="vehicle">Track by Vehicle</label><br />
                    <input
                      type="radio"
                      name="driver"
                      value="driver"
                      id="driver"
                      v-model="primaryTrip.trackBy"
                      @change="onSelectRadio('driver')"
                    />
                    <label for="driver">Track by Driver</label>
                  </div>
                </div>
              </vue-form>

              <div class="col-sm-12 text-right">
                <a v-if="$route.params && $route.params._id == '0'">
                  <router-link :to="{ name: 'Primarytrip' }">
                    <button class="mr-5 btn btn-default" type="button">Cancel</button>
                  </router-link>
                </a>
                <a v-if="$route.params && $route.params._id && $route.params._id != '0'">
                  <router-link
                    :to="{
                      name: 'viewPrimaryTrip',
                      params: { _id: $route.params._id },
                    }"
                  >
                    <button class="mr-5 btn btn-default" type="button">Cancel</button>
                  </router-link>
                </a>
                <button
                  class="mr-2 btn gradientbt"
                  type="submit"
                  @click="createTrip"
                  :disabled="!(formstate.$dirty && formstate.$valid && selectDate)"
                  v-if="$route.params && $route.params._id == '0'"
                >
                  Save
                </button>

                <button
                  class="mr-2 btn gradientbt"
                  type="submit"
                  @click="updateTrip"
                  :disabled="
                    !(
                      (formstate.$dirty ||
                        selectDate ||
                        showDivision ||
                        isTrackBySelected) &&
                      formstate.$valid
                    )
                  "
                  v-if="$route.params && $route.params._id && $route.params._id != '0'"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  eventBus,
  formService,
  authService,
  primarytripService,
} from "../../../services";
import { EVENTS } from "../../../config";
import { log } from "console";
import { Multiselect } from "vue-multiselect";

export default {
  name: "PrimaryTripCreate",
  components: {
    Multiselect,
  },
  data() {
    return {
      isCityDisable: false,
      cities: {},
      loading: false,
      showDivision: false,
      flash: false,
      flashType: null,
      flashMessage: "",
      EVENTS: EVENTS,
      formstate: {},
      area: {},
      driver_name: {},
      helper_name: {},
      division_ward: {},
      vehicle_name: {},
      divisionWardList: [],
      // tpOrSegegrationOrDumpyard: {},
      primaryTrip: {
        cdId: [],
        cityId: "",
        vehicleId: "",
        caId: "",
        driverId: "",
        helperId: "",
        endLoc: "",
        trackBy: "driver",
      },
      lineOrTowers: {},
      endLocations: null,
      valu: null,
      options: ["list", "of", "options"],
      collection_ids: [],
      tripStatus: "upcoming",
      value: [],
      selectDate: false,
      isTrackBySelected: false,
      options: [
        {
          name: "Vue.js",
          code: "vu",
        },
        {
          name: "Javascript",
          code: "js",
        },
        {
          name: "Open Source",
          code: "os",
        },
      ],
    };
  },
  mounted: function () {
    this.getCityList();
    eventBus.$on("cityIdChanged", this.onChecked);
    if (
      this.$store.state.auth.user.role.key !== "cityAdmin" &&
      this.$store.state.auth.user.role.key !== "superVisor"
    ) {
      this.isCityDisable = true;
      this.primaryTrip.cityId = this.$store.state.auth.cityId.value;
      this.getCityId(this.$store.state.auth.cityId.value);
    }
  },
  beforeDestroy() {
    eventBus.$off("cityIdChanged", this.onChecked);
  },
  methods: {
    fieldClassName: formService.fieldClassName,

    onSelectRadio(option) {
      this.selectedOption = option;
      this.isTrackBySelected = true;
    },

    onChecked(option) {
      this.primaryTrip.cityId = option.value;

      this.getCityId(option.value);
    },
    selectItem(value) {
      if (value.length > 0) {
        this.selectDate = true;
      } else {
        this.selectDate = false;
      }
    },
    showWard() {
      if (this.primaryTrip) {
        this.showDivision = true;
      }
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    getArea(id) {
      this.loading = true;
      let arealist = [];
      return primarytripService
        .getWasteCollectionAreaList(id)
        .then((res) => {
          this.loading = false;
          res.data.response.forEach((element) => {
            arealist.push({
              name: element.areaName,
              id: element._id,
            });
          });
          arealist.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.area = arealist;
        })
        .catch((error) => {
          this.loading = false;
          console.error("getWasteCollectionAreaList.requestFunction-error:", error);
          this.$snotify.error("Get Ward Details List  failed", "Error!");
        });
    },
    getAreaById(id) {
      this.primaryTrip.cdId = "";
      this.primaryTrip.driverId = "";
      this.primaryTrip.helperId = "";
      this.primaryTrip.vehicleId = "";
      this.primaryTrip.endLoc = "";
      this.primaryTrip.scheduleTime = "";

      this.getAreaByIds(id);
      this.getEndLocationsAreas(id);
    },
    getAreaByIds(id) {
      this.loading = true;
      let areaListById = [];
      return primarytripService
        .getWasteDivisionsListById(id)
        .then((res) => {
          this.loading = false;
          res.data.response.forEach((element) => {
            element.divisionData.forEach((a) => {
              areaListById.push({
                cdName: a.cdName,
                _id: a._id,
              });
            });
          });
          areaListById.sort((item1, item2) => {
            return item1.cdName.toLowerCase() < item2.cdName.toLowerCase() ? -1 : 1;
          });
          this.division_ward = areaListById;
          this.divisionWardList = areaListById;
        })
        .catch((error) => {
          this.loading = false;
          console.error("Get Waste Divisions List By Id.Primary Trip-error:", error);
        });
    },

    getDriverList(id) {
      let driver_nameList = [];
      return primarytripService
        .driverList(id)
        .then((res) => {
          res.data.response.forEach((element) => {
            if (element.status == true) {
              driver_nameList.push({
                name: element.firstName + " " + element.lastName,
                id: element._id,
              });
            }
          });
          driver_nameList.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.driver_name = driver_nameList;
        })
        .catch((error) => {
          this.loading = false;
          console.error("Driver.requestFunction-error:", error);
          this.$snotify.error("Driver list failed", "Error!");
        });
    },

    getHelperList(id) {
      let helper_nameList = [];
      return primarytripService
        .helperList(id)
        .then((res) => {
          res.data.response.forEach((element) => {
            if (element.status == true) {
              helper_nameList.push({
                name: element.firstName + " " + element.lastName,
                id: element._id,
              });
            }
          });
          helper_nameList.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.helper_name = helper_nameList;
        })
        .catch((error) => {
          this.loading = false;
          console.error("Helper.requestFunction-error:", error);
          this.$snotify.error("Helper list failed", "Error!");
        });
    },

    getVehicleList(id) {
      let vehicle_nameList = [];
      return primarytripService
        .vehicleList(id)
        .then((res) => {
          res.data.response.forEach((element) => {
            if (element.status == true) {
              // if (element.vType === "Primary(Small)") {
              vehicle_nameList.push({
                name: element.vNumber,
                id: element._id,
              });
              // }
            }
          });
          vehicle_nameList.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.vehicle_name = vehicle_nameList;
        })
        .catch((error) => {
          this.loading = false;
          console.error("Vehicle.requestFunction-error:", error);
          this.$snotify.error("Vehicle list failed", "Error!");
        });
    },

    getEndLocationsAreas(id) {
      return primarytripService
        .getEndLocationsAreas(id)
        .then((res) => {
          this.loading = false;
          let endlocationSort = res.data.response;
          endlocationSort.sort((item1, item2) => {
            return item1.plantName.toLowerCase() < item2.plantName.toLowerCase() ? -1 : 1;
          });

          this.endLocations = endlocationSort;
        })
        .catch((error) => {
          this.loading = false;
          console.error("getLineAndTowerByDivisions.getAreaById-error:", error);
        });
    },

    createTrip() {
      this.loading = true;
      let tripInfo = {};
      tripInfo.collectionDataInfo = [];
      tripInfo.caId = this.primaryTrip.caId;
      // tripInfo.cdId = []
      tripInfo.cdId = this.primaryTrip.cdId.map((el) => el._id);
      tripInfo.driverId = this.primaryTrip.driverId;
      // tripInfo.endLoc = this.primaryTrip.endLoc;
      tripInfo.scheduleTime = this.primaryTrip.scheduleTime;
      tripInfo.tripStatus = this.tripStatus;
      tripInfo.trackBy = this.primaryTrip.trackBy;
      tripInfo.vehicleId = this.primaryTrip.vehicleId;
      // tripInfo.helperId = this.primaryTrip.helperId;
      tripInfo.cityId = this.primaryTrip.cityId;
      if (this.primaryTrip.helperId) {
        tripInfo.helperId = this.primaryTrip.helperId;
      }
      return primarytripService
        .addPrimaryTrip(tripInfo)
        .then((response) => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success("Primary Trip has been added successfully.");
          this.$router.push({
            name: "viewPrimaryTrip",
            params: {
              _id: response.data._id,
            },
          });
        })
        .catch((error) => {
          this.loading = false;
          this.$snotify.error(errorMessage, "Error!");
        });
    },

    updateTrip() {
      this.loading = true;
      // this.primaryTrip.collectionDataInfo =[] ;
      let tripInfo = {};
      tripInfo.collectionDataInfo = [];
      tripInfo.caId = this.primaryTrip.caId;
      tripInfo.cdId = this.primaryTrip.cdId.map((el) => el._id);
      tripInfo.driverId = this.primaryTrip.driverId;
      // tripInfo.endLoc = this.primaryTrip.endLoc;
      tripInfo.scheduleTime = this.primaryTrip.scheduleTime;
      tripInfo.tripStatus = this.tripStatus;
      tripInfo.vehicleId = this.primaryTrip.vehicleId;
      tripInfo.trackBy = this.primaryTrip.trackBy;
      // tripInfo.helperId = this.primaryTrip.helperId;

      if (this.primaryTrip.helperId != "") {
        tripInfo.helperId = this.primaryTrip.helperId;
      } else {
        delete tripInfo.helperId;
      }
      if (this.$route.params._id != "0") {
        tripInfo._id = this.$route.params._id;
      }
      tripInfo.cityId = this.primaryTrip.cityId;

      // this.primaryTrip['_id'] = this.
      return primarytripService
        .updatePrimaryTrip(tripInfo)
        .then((response) => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success("Primary Trip has been updated successfully.");
          this.$router.push({
            name: "viewPrimaryTrip",
            params: {
              _id: response.data._id,
            },
          });
        })
        .catch((error) => {
          this.loading = false;
          this.$snotify.error(errorMessage, "Error!");
        });
    },

    getTrip() {
      return primarytripService
        .getById(this.$route.params._id)
        .then((response) => {
          let cdIds = response.data.cdId.map((element) => element._id);
          this.getCityId(response.data.cityId._id);
          this.getAreaById(response.data.caId._id);
          this.primaryTrip["cityId"] = response.data.cityId._id;
          this.primaryTrip["caId"] = response.data.caId._id;
          // this.primaryTrip['cdId'] = [...cdIds]
          this.primaryTrip["cdId"] = response.data.cdId;
          this.primaryTrip["driverId"] = response.data.driverId._id;
          this.primaryTrip["endLoc"] = response.data.endLoc._id;
          this.primaryTrip["scheduleTime"] = response.data.scheduleTime;
          this.primaryTrip["trackBy"] = response.data.trackBy;
          this.primaryTrip["tripStatus"] = response.data.tripStatus;
          this.primaryTrip["vehicleId"] = response.data.vehicleId._id;
          if (response.data.helperId !== null) {
            this.primaryTrip["helperId"] = response.data.helperId._id;
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("tripDetails.getTripDetails-error:", error);
        });
    },

    getCityList() {
      if (
        this.$store.state.auth.user.role.key === "cityAdmin" ||
        this.$store.state.auth.user.role.key === "superVisor" ||
        this.$store.state.auth.user.role.key === "subCityAdmin"
      ) {
        const { _id, cityName } = this.$store.state.auth.user.cityId;
        this.cities = [
          {
            id: _id,
            name: cityName,
          },
        ];
        this.getCityId(_id);
        this.primaryTrip["cityId"] = _id;
        this.isCityDisable = true;

        return;
      }
      this.loading = true;
      const params = {};
      let cityList = [];
      this.$cityRepository
        .collectionCitysList(params)
        .then((res) => {
          this.loading = false;
          res.data.response.forEach((element) => {
            if (element.status === true) {
              cityList.push({
                name: element.cityName,
                id: element._id,
              });
            }
          });
          cityList.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.cities = cityList;
        })
        .catch((error) => {
          this.loading = false;
          console.error("cities.requestFunction-error:", error);
          this.$snotify.error("Get cities list failed", "Error!");
        });
    },

    getCityId(cityId) {
      this.primaryTrip.caId = "";
      this.primaryTrip.cdId = "";
      this.primaryTrip.driverId = "";
      this.primaryTrip.helperId = "";
      this.primaryTrip.vehicleId = "";
      this.primaryTrip.endLoc = "";
      this.primaryTrip.scheduleTime = "";

      this.getArea(cityId);
      // this.getEndLocations(cityId);
      this.getDriverList(cityId);
      this.getHelperList(cityId);
      this.getVehicleList(cityId);
    },
    reset() {
      this.primaryTrip.cdId = null;
      this.divisionWardList = [];
      this.formstate._reset();
    },
  },
  // watch: {
  //   selectedMember: function (val) {
  //     if (val) {
  //       this.getConversation({ user: val })
  //     }
  //   }
  // },

  created() {
    const promises = [];
    this.loading = true;

    if (this.$route.params && this.$route.params._id && this.$route.params._id != "0") {
      promises.push(this.getTrip());
    }
    Promise.all(promises)
      .then(() => {
        this.loading = false;
        this.ready = true;
      })
      .catch(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
h4 {
  font-weight: bold;
}

.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
}

.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}

.has-danger {
  color: red;
}

.mt {
  margin-top: 7px;
}

.gradientbt {
  background: #0f6940;
  color: white;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.collection_time_date_icon svg {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 22px;
  top: 32px;
}
</style>



// WEBPACK FOOTER //
// addPrimaryTrip.vue?73e36477